/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface ICollaborativeEditingConnectMessage extends IMessage {
	id: string;
	bundleVersion: string;
	buffers: Buffer[];
	types: number[];
	lastOperationId?: string;
}

export default class CollaborativeEditingConnectMessage extends Message {
	public static readonly TYPE: string = '11';

	public static readonly READABLE_TYPE_NAME: string = 'connectToDocument';

	public static readonly DESCRIPTOR_NAME: string = 'CollaborativeEditingConnectMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			id: {
				type: 'string',
				id: 1
			},
			bundleVersion: {
				type: 'string',
				id: 2
			},
			buffers: {
				rule: 'repeated',
				type: 'bytes',
				id: 3
			},
			types: {
				rule: 'repeated',
				type: 'uint32',
				id: 4
			},
			lastOperationId: {
				type: 'string',
				id: 5
			}
		}
	};

	public constructor(
		public readonly id: string,
		public readonly buffers: Buffer[],
		public readonly types: number[],
		public readonly bundleVersion: string,
		public readonly lastOperationId: string = ''
	) {
		super();
	}

	public toJSON(): ICollaborativeEditingConnectMessage {
		return {
			id: this.id,
			buffers: this.buffers,
			types: this.types,
			bundleVersion: this.bundleVersion,
			lastOperationId: this.lastOperationId
		};
	}

	public static fromJSON( data: ICollaborativeEditingConnectMessage ): CollaborativeEditingConnectMessage {
		return new CollaborativeEditingConnectMessage(
			data.id,
			data.buffers,
			data.types,
			data.bundleVersion,
			data.lastOperationId
		);
	}
}
